import React from 'react';

const ImageIcon = ({ iUrl, alt, ...props }) => (
  <img
    src={iUrl}
    alt={alt}
    style={{ width: '48px', height: '48px', ...props.style }}  // Set base size and allow overrides with props
    {...props}
  />
);

const TrendUpIcon = () => (
  <ImageIcon iUrl={'https://storage.googleapis.com/finiat-web-static-resources/platformIcons/trend-up-3d.png'} alt="Trend Up Icon" />
);

const TrendDownIcon = () => (
  <ImageIcon iUrl={'https://storage.googleapis.com/finiat-web-static-resources/platformIcons/trend-down.png'} alt="Trend Down Icon" />
);


const CurveUpIcon = () => (
  <ImageIcon iUrl={'https://storage.googleapis.com/finiat-web-static-resources/platformIcons/arrow-curve-up.png'} alt="Trend Up Icon" />
);

const CurveDownIcon = () => (
  <ImageIcon iUrl={'https://storage.googleapis.com/finiat-web-static-resources/platformIcons/arrow-curve-down-ban-circle.png'} alt="Trend Down Icon" />
);

export {
  TrendUpIcon,
  TrendDownIcon,
    CurveUpIcon,
    CurveDownIcon
};
